import { render, staticRenderFns } from "./PushStupNoPopup.vue?vue&type=template&id=20d02871"
import script from "./PushStupNoPopup.vue?vue&type=script&lang=js"
export * from "./PushStupNoPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d02871')) {
      api.createRecord('20d02871', component.options)
    } else {
      api.reload('20d02871', component.options)
    }
    module.hot.accept("./PushStupNoPopup.vue?vue&type=template&id=20d02871", function () {
      api.rerender('20d02871', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/PushStupNoPopup.vue"
export default component.exports